import useFetch from "../../global/hooks/useFetch";
import useMutation from "../../global/hooks/useMutation";

export const usePayouts = (page = 1, pageSize = 10) => {
  const { data, loading, refetch } = useFetch(
    `/payouts/?page=${page}&page_size=${pageSize}`,
  );
  const {
    mutate: createPayoutMutation,
    loading: creating,
    error: createError,
  } = useMutation("/payouts/", "POST");

  const createPayout = async (payoutData) => {
    const createdPayout = await createPayoutMutation(payoutData);
    await refetch();
    return createdPayout;
  };

  return {
    payouts: data?.results || [],
    pagination: {
      count: data?.count || 0,
      next: data?.next,
      previous: data?.previous,
    },
    loading,
    createPayout,
    creating,
    createError,
    refetch,
  };
};

export const useDeletePayout = () => {
  const deletePayout = async (payoutId) => {
    const token = localStorage.getItem("accessToken");

    const response = await fetch(
      `${process.env.REACT_APP_API_URL || "http://localhost:8000"}/payouts/${payoutId}/`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || "Failed to delete payout");
    }

    return true;
  };

  return {
    deletePayout,
    deleting: false,
    deleteError: null,
  };
};

export const useProducerAssetBalances = (userId) => {
  const { data, loading, refetch } = useFetch(
    userId ? `/analytics/producer-balances/${userId}/` : null,
  );
  return { balances: data || [], loading, refetch };
};

export const usePayout = (payoutId) => {
  const { data: payout, loading, refetch } = useFetch(`/payouts/${payoutId}/`);
  const {
    mutate: updatePayoutMutation,
    loading: updating,
    error: updateError,
  } = useMutation(`/payouts/${payoutId}/`, "PUT");
  const {
    mutate: deletePayoutMutation,
    loading: deleting,
    error: deleteError,
  } = useMutation(`/payouts/${payoutId}/`, "DELETE");

  const updatePayout = async (payoutData) => {
    const updatedPayout = await updatePayoutMutation(payoutData);
    await refetch();
    return updatedPayout;
  };

  const deletePayout = async () => {
    await deletePayoutMutation();
    return true;
  };

  return {
    payout,
    loading,
    updatePayout,
    updating,
    updateError,
    deletePayout,
    deleting,
    deleteError,
    refetch,
  };
};
